package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.activity.ActivityScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_activity
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteActivity : RouteParameterTo

object RouterActivity : RouterNoParameters<RouteActivity>(RouteActivity::class) {
    override fun routeFrom(parameters: RouteActivity) = "/activity"

    @Composable
    override fun Show(parameters: RouteActivity) {
        RouteActivityImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteActivity,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteActivity

    override fun isMatching(route: String) = route == "/activity"

    override fun navigateFrom(path: String) = RouteActivity
}

class RouteActivityImpl : Route<RouteActivity>(
    route = "/activity",
    params = RouteActivity,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.title_activity,
                    listOf(
                        MenuItem.MenuItemSimple(
                            imageVector = Icons.Rounded.Logout,
                            onClick = { appModel.logout() }
                        )
                    )
                )
            )
        }

        val state by appModel.states.collectAsState()
        val api = state.apiProvider?.apiNormal ?: return

        ActivityScreen(api = api)
    }
}
